var _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTournamentCommentsSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.5H14.25C16.0449 5.5 17.5 6.95507 17.5 8.75V10.25C17.5 12.0449 16.0449 13.5 14.25 13.5H10.6L7.25 16V13.5H5.75C3.95508 13.5 2.5 12.0449 2.5 10.25V8.75C2.5 6.95507 3.95508 5.5 5.75 5.5Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5H12",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.75C20.5 15.5449 19.0449 17 17.25 17H15.75V19.25L12.95 17H12.25C10.4551 17 9 15.5449 9 13.75V13.5H14.25C16.5972 13.5 18.5 11.5972 18.5 9.25V8.5H17.25C19.0449 8.5 20.5 9.95508 20.5 11.75V13.75Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 12.75,
    r: 0.85,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1,
    cy: 12.75,
    r: 0.85,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentCommentsSidebar);
export default __webpack_public_path__ + "static/media/tournamentCommentsSidebar.6ca5c84110282fd1a7fdaaadff696cc7.svg";
export { ForwardRef as ReactComponent };